import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import SectionTitle from '../components/SectionTitle/SectionTitle';
import SEO from '../components/SEO/SEO';
import { getServiceListSchema } from '../components/SEO/schema';
import './Services.scss';
import { useTranslation } from 'react-i18next';
import getServicesData from '../sections/Services/ServiceData';

const Services = () => {
    const { t } = useTranslation();
    const servicesData = getServicesData(t);

    return (
        <>
            <SEO
                title="Zahnärztliche Leistungen | Zahnarzt Tönisvorst"
                description="Prophylaxe, Implantate, Wurzelbehandlung unter dem OP-Mikroskop, Zweitmeinung u.v.m. – alle zahnärztlichen Leistungen der Zahnarztpraxis Roman Boretskyi in Tönisvorst."
                path="/leistungen"
                jsonLd={getServiceListSchema(servicesData)}
            />
            <section className='section-bg section-common services-page-section'>
                <Navbar />
                <SectionTitle 
                    title={t('services.title')}
                    description={t('services.description')}
                />
            </section>
            
            <section className='services-content-area pt-100 pb-70'>
                <div className="container">
                    <div className="services-grid">
                        {
                            servicesData.map((service, index) => (
                                <div key={index} className="service-card" data-aos="fade-up" data-aos-delay={Math.min(index * 60, 300)}>
                                    <div className="service-icon">
                                        {service.icon}
                                    </div>
                                    <div className="service-content">
                                        <h3>{service.title}</h3>
                                        <p>{service.description}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Services;